export interface BillingPurchaseReadiness {
  organizationId: string;
  featureAccessReady: boolean;
  featureAccessError: boolean;
  plansReady: boolean;
  plansError: boolean;
  isAppSumoOnly?: boolean;
  trialActive?: boolean;
}

/** Purchase controls fail closed until both tenant-scoped billing reads have
 * completed successfully. This keeps a transient missing trial payload from
 * exposing top-ups that the server will reject. */
export const canOfferStripePurchases = ({
  organizationId,
  featureAccessReady,
  featureAccessError,
  plansReady,
  plansError,
  isAppSumoOnly = false,
}: BillingPurchaseReadiness) =>
  Boolean(organizationId) &&
  featureAccessReady &&
  !featureAccessError &&
  plansReady &&
  !plansError &&
  !isAppSumoOnly;

export const canOfferCreditTopups = (readiness: BillingPurchaseReadiness) =>
  // `trialActive !== true`, not `=== false`: orgs with no trial state at all
  // (every org that predates trials) pass `undefined` here, and they must
  // keep buying top-ups exactly as they do today. Loading states are already
  // fail-closed via canOfferStripePurchases' readiness gates.
  canOfferStripePurchases(readiness) && readiness.trialActive !== true;
